import { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

import { useClientSuspense } from "@/api/clients/queries";
import { Client } from "@/api/clients/types";
import ClientComponent from "@/routes/clients/Client";

type ClientContextType = { client: Client };
const ClientContext = createContext<ClientContextType | null>(null);

export const useClientContext = () => {
  const ctx = useContext(ClientContext);
  if (!ctx)
    throw new Error("useClientContext must be used within ClientDataLoader");
  return ctx.client;
};

export function ClientDataLoader() {
  const { clientId } = useParams();

  if (!clientId) {
    throw new Response("Client ID is required", { status: 404 });
  }

  const { data: client } = useClientSuspense({ id: clientId });

  if (!client) {
    throw new Response("Client not found", { status: 404 });
  }

  return (
    <ClientContext.Provider value={{ client }}>
      <ClientComponent />
    </ClientContext.Provider>
  );
}
